import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '../../core/stores/authStore.js';
import { Skeleton } from '../ui/Skeleton.jsx';

/**
 * @param {{ children: import('react').ReactNode }} props
 */
export function ProtectedRoute({ children }) {
  const currentUser = useAuthStore((s) => s.currentUser);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col gap-4 p-4">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/welcome" state={{ from: location }} replace />;
  }

  return children;
}
